/**
 * @generated SignedSource<<fc53e19015ccd69e4d27132613aa5dcc>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SubmissionsCompetitionApprovalsFragment$data = {
  readonly id: string;
  readonly slug: string;
  readonly submissions: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly entity: {
          readonly username: string;
          readonly " $fragmentSpreads": FragmentRefs<"EntityProfilePicFragment">;
        };
        readonly id: string;
        readonly latest: {
          readonly approvalsCheck: {
            readonly nodes: ReadonlyArray<{
              readonly viewerCanRead: boolean;
            }>;
          };
          readonly id: string;
          readonly version: string;
          readonly viewerCanReadFiles: boolean;
          readonly " $fragmentSpreads": FragmentRefs<"BaseProjectVersionApprovalButtonFragment" | "SubmissionApprovalsFragment" | "SubmissionStatusBadgeFragment">;
        } | null | undefined;
      };
    }>;
  };
  readonly viewerCanApprove: boolean;
  readonly " $fragmentType": "SubmissionsCompetitionApprovalsFragment";
};
export type SubmissionsCompetitionApprovalsFragment$key = {
  readonly " $data"?: SubmissionsCompetitionApprovalsFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"SubmissionsCompetitionApprovalsFragment">;
};

import CompetitionApprovalsFragmentPaginationQuery_graphql from './CompetitionApprovalsFragmentPaginationQuery.graphql';

const node: ReaderFragment = (function(){
var v0 = [
  "submissions"
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "approvalFilter"
    },
    {
      "defaultValue": 10,
      "kind": "LocalArgument",
      "name": "count"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "cursor"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "count",
        "cursor": "cursor",
        "direction": "forward",
        "path": (v0/*: any*/)
      }
    ],
    "refetch": {
      "connection": {
        "forward": {
          "count": "count",
          "cursor": "cursor"
        },
        "backward": null,
        "path": (v0/*: any*/)
      },
      "fragmentPathInResult": [
        "node"
      ],
      "operation": CompetitionApprovalsFragmentPaginationQuery_graphql,
      "identifierInfo": {
        "identifierField": "id",
        "identifierQueryVariableName": "id"
      }
    }
  },
  "name": "SubmissionsCompetitionApprovalsFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "slug",
      "storageKey": null
    },
    {
      "alias": "viewerCanApprove",
      "args": [
        {
          "kind": "Literal",
          "name": "action",
          "value": "CREATE_PROJECT_VERSION_APPROVAL"
        }
      ],
      "kind": "ScalarField",
      "name": "viewerCan",
      "storageKey": "viewerCan(action:\"CREATE_PROJECT_VERSION_APPROVAL\")"
    },
    {
      "alias": "submissions",
      "args": [
        {
          "kind": "Variable",
          "name": "approvalFilter",
          "variableName": "approvalFilter"
        }
      ],
      "concreteType": "SubmissionConnection",
      "kind": "LinkedField",
      "name": "__CompetitionApprovalsFragment_submissions_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "SubmissionEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Submission",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v1/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "concreteType": null,
                  "kind": "LinkedField",
                  "name": "entity",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "username",
                      "storageKey": null
                    },
                    {
                      "args": [
                        {
                          "kind": "Literal",
                          "name": "thumbnail",
                          "value": true
                        }
                      ],
                      "kind": "FragmentSpread",
                      "name": "EntityProfilePicFragment"
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "ProjectVersion",
                  "kind": "LinkedField",
                  "name": "latest",
                  "plural": false,
                  "selections": [
                    (v1/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "version",
                      "storageKey": null
                    },
                    {
                      "alias": "viewerCanReadFiles",
                      "args": [
                        {
                          "kind": "Literal",
                          "name": "action",
                          "value": "READ_PROJECT_VERSION_FILE"
                        }
                      ],
                      "kind": "ScalarField",
                      "name": "viewerCan",
                      "storageKey": "viewerCan(action:\"READ_PROJECT_VERSION_FILE\")"
                    },
                    {
                      "alias": "approvalsCheck",
                      "args": [
                        {
                          "kind": "Literal",
                          "name": "first",
                          "value": 2
                        }
                      ],
                      "concreteType": "ProjectVersionApprovalConnection",
                      "kind": "LinkedField",
                      "name": "approvals",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "ProjectVersionApproval",
                          "kind": "LinkedField",
                          "name": "nodes",
                          "plural": true,
                          "selections": [
                            {
                              "alias": "viewerCanRead",
                              "args": [
                                {
                                  "kind": "Literal",
                                  "name": "action",
                                  "value": "READ_PROJECT_VERSION_APPROVAL"
                                }
                              ],
                              "kind": "ScalarField",
                              "name": "viewerCan",
                              "storageKey": "viewerCan(action:\"READ_PROJECT_VERSION_APPROVAL\")"
                            }
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": "approvals(first:2)"
                    },
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "SubmissionStatusBadgeFragment"
                    },
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "BaseProjectVersionApprovalButtonFragment"
                    },
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "SubmissionApprovalsFragment"
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endCursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNextPage",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    (v1/*: any*/)
  ],
  "type": "Competition",
  "abstractKey": null
};
})();

(node as any).hash = "aa996729c58f2f57f29bf4067695f3f1";

export default node;
